"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugPurchasesUpdatePatchRequestToJSON = exports.ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSONTyped = exports.ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSON = exports.instanceOfApiStoresUrlSlugPurchasesUpdatePatchRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ApiStoresUrlSlugPurchasesUpdatePatchRequest interface.
 */
function instanceOfApiStoresUrlSlugPurchasesUpdatePatchRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugPurchasesUpdatePatchRequest = instanceOfApiStoresUrlSlugPurchasesUpdatePatchRequest;
function ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSON(json) {
    return ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSON = ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSON;
function ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
    };
}
exports.ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSONTyped = ApiStoresUrlSlugPurchasesUpdatePatchRequestFromJSONTyped;
function ApiStoresUrlSlugPurchasesUpdatePatchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reference_id': value.referenceId,
        'email': value.email,
    };
}
exports.ApiStoresUrlSlugPurchasesUpdatePatchRequestToJSON = ApiStoresUrlSlugPurchasesUpdatePatchRequestToJSON;
